import { apiGateway } from '@va/api-client';
import { getInstanceId } from '@va/dashboard/selectors/app';
import { PrivacyLevelsEnum, PrivacyLevelType } from '@va/standalone/shared/types';
import { emptyArrayOfN } from '@va/util/helpers';
import { useAsyncFunction } from '@va/util/hooks';
import { useCallback } from 'react';
import { useSelector } from 'react-redux';

type PrivacyLevelResponseType = {
  payload: PrivacyLevelType[];
};

export const useUpdatePrivacySettings = () => {
  const websiteId = useSelector(getInstanceId);

  const asyncFunc = useCallback(
    async (data: PrivacyLevelType[]) => {
      return await apiGateway.put<PrivacyLevelResponseType>(`/v1/websites/${websiteId}/privacy-center/settings`, data);
    },
    [websiteId],
  );

  return useAsyncFunction(asyncFunc);
};

export const buildDataPrivacyPayload = (value: PrivacyLevelsEnum) => {
  return emptyArrayOfN(4).map((_, index) => ({
    levelKey: index,
    selected: index === value,
    exceptions: [],
  }));
};
